<template>
  <div class="facts-scorecard">
    <div class="sticky-sidebar">
      <div class="facts-scorecard__inner panel">
        <div class="facts-scorecard__inner-title">
          <h4 class="m-b--0 text-KQ-Gray4">KQ Facts Scorecard</h4>
          <button
            type="button"
            class="button button--text"
            :disabled="activeFilter === ''"
            @click="resetFilters"
          >
            Reset
          </button>
        </div>
        <div class="facts-scorecard__inner-header">
          <p>True vs False</p>
          <p>Articles</p>
        </div>
        <ul>
          <li :class="{ active: activeFilter === 'happy' }">
            <button
              role="button"
              aria-label="Optional description of what happens when the link is clicked"
              class="happy"
              @click="filterElements('happy')"
            >
              <div class="fact-stats">
                <i class="icon icon-face-happy icon--sm" aria-hidden="true"></i>
                <div class="progress-bar">
                  <div
                    class="happy-progress"
                    :style="{ width: happyProgress + '%' }"
                  ></div>
                </div>
                <h5>{{ happyCount }}</h5>
              </div>
            </button>
          </li>
          <li :class="{ active: activeFilter === 'smile' }">
            <button
              role="button"
              aria-label="Optional description of what happens when the link is clicked"
              class="smile"
              @click="filterElements('smile')"
            >
              <div class="fact-stats">
                <i class="icon icon-face-smile icon--sm" aria-hidden="true"></i>
                <div class="progress-bar">
                  <div
                    class="smile-progress"
                    :style="{ width: smileProgress + '%' }"
                  ></div>
                </div>
                <h5>{{ smileCount }}</h5>
              </div>
            </button>
          </li>
          <li :class="{ active: activeFilter === 'sad' }">
            <button
              role="button"
              aria-label="Optional description of what happens when the link is clicked"
              class="sad"
              @click="filterElements('sad')"
            >
              <div class="fact-stats">
                <i class="icon icon-face-sad icon--sm" aria-hidden="true"></i>
                <div class="progress-bar">
                  <div
                    class="sad-progress"
                    :style="{ width: sadProgress + '%' }"
                  ></div>
                </div>
                <h5>{{ sadCount }}</h5>
              </div>
            </button>
          </li>
          <li :class="{ active: activeFilter === 'upset' }">
            <button
              role="button"
              aria-label="Optional description of what happens when the link is clicked"
              class="upset"
              @click.prevent="filterElements('upset')"
            >
              <div class="fact-stats">
                <i class="icon icon-face-upset icon--sm" aria-hidden="true"></i>
                <div class="progress-bar">
                  <div
                    class="upset-progress"
                    :style="{ width: upsetProgress + '%' }"
                  ></div>
                </div>
                <h5>{{ upsetCount }}</h5>
              </div>
            </button>
          </li>
        </ul>
      </div>
      <slot name="social"></slot>
    </div>
  </div>
  <div class="facts">
    <p class="heading-h2">{{ title }}</p>
    <div class="facts-accordions">
      <slot></slot>
      <button
        v-if="showMoreButton"
        role="button"
        aria-label="Optional description of what happens when the link is clicked"
        class="button button--outlined show-more-button m-t--32"
        @click="showMore"
      >
        Show all
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    happyCount: {
      type: Number,
      default: 0,
    },
    smileCount: {
      type: Number,
      default: 0,
    },
    sadCount: {
      type: Number,
      default: 0,
    },
    upsetCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeFilter: '',
      showMoreButton: true,
    };
  },
  computed: {
    happyProgress() {
      if (this.happyCount === 0) {
        return 0;
      } else {
        return 100;
      }
    },
    smileProgress() {
      if (this.smileCount === 0) {
        return 0;
      } else {
        return (this.smileCount / this.happyCount) * 100;
      }
    },
    sadProgress() {
      if (this.sadCount === 0) {
        return 0;
      } else {
        return (this.sadCount / this.happyCount) * 100;
      }
    },
    upsetProgress() {
      if (this.upsetCount === 0) {
        return 0;
      } else {
        return (this.upsetCount / this.happyCount) * 100;
      }
    },
  },
  mounted() {
    this.hideChildElements();
  },
  methods: {
    hideChildElements() {
      const parent = document.querySelector('.facts-accordions');
      const childElements = parent.querySelectorAll('.accordion');
      for (let i = 8; i < childElements.length; i++) {
        childElements[i].style.display = 'none';
      }
    },
    showMore() {
      const parent = document.querySelector('.facts-accordions');
      const childElements = parent.querySelectorAll('.accordion');
      const hiddenElements = [...childElements].filter(
        (element) => element.style.display === 'none',
      );

      for (let i = 0; i < 8 && i < hiddenElements.length; i++) {
        hiddenElements[i].style.display = '';
      }

      if (hiddenElements.length <= 8) {
        this.showMoreButton = false;
      }
    },
    filterElements(filter) {
      document.querySelector('.factchecker-accordions').scrollIntoView({ behavior: 'smooth' });
      this.showMoreButton = false;
      this.activeFilter = filter;
      let elements =
        document.getElementsByClassName('facts-accordions')[0].children;
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'block';
      }
      switch (filter) {
        case 'happy':
          for (let i = 0; i < elements.length; i++) {
            if (!elements[i].classList.contains('happy')) {
              elements[i].style.display = 'none';
            }
          }
          break;
        case 'smile':
          for (let i = 0; i < elements.length; i++) {
            if (!elements[i].classList.contains('smile')) {
              elements[i].style.display = 'none';
            }
          }
          break;
        case 'sad':
          for (let i = 0; i < elements.length; i++) {
            if (!elements[i].classList.contains('sad')) {
              elements[i].style.display = 'none';
            }
          }
          break;
        case 'upset':
          for (let i = 0; i < elements.length; i++) {
            if (!elements[i].classList.contains('upset')) {
              elements[i].style.display = 'none';
            }
          }
          break;
        default:
          break;
      }
    },
    resetFilters() {
      this.activeFilter = '';
      const elements =
        document.getElementsByClassName('facts-accordions')[0].children;
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = i < 8 ? 'block' : 'none';
      }
      this.showMoreButton = true;
    },
  },
};
</script>
